module.exports = __webpack_public_path__ + "img/battle-text.425d36ab.png";